import Vue from 'vue';
import Router from 'vue-router';
import pathKey from './routerKey';
import ErrorPage from '@/components/error/errorPage'
import HomePage from '@/components/home/homePage';
import LoginPage from '@/components/login/loginPage';
import FamilyPage from '@/components/pages/familyStatus/familyStatus';
import InfoManagePage from '@/components/pages/infoManage/infoManage';
import AfterSaleManage from '@/components/pages/afterSaleManage/afterSaleManage';
import EquipmentPage from '@/components/pages/familyStatus/equipmentPages/equipmentPage';
import FamilyStatusDetail from '@/components/pages/familyStatus/statusPages/statusManage';
import WaterPage from '@/components/pages/familyStatus/statusPages/waterPage';
import GasPage from '@/components/pages/familyStatus/statusPages/gasPage';
import ElectricityPage from '@/components/pages/familyStatus/statusPages/electricityPage';
import EnvironmentPage from '@/components/pages/familyStatus/statusPages/environmentPage';
import EnergyDetailPage from '@/components/pages/familyStatus/statusPages/detailPages/energyDetail';
import SmartEnergyPage from '@/components/pages/familyStatus/statusPages/smartEnergyPage';

Vue.use(Router)

export default new Router({
  // base: '/web/',
  mode: 'hash',
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return {x:0, y:0};
    }
  },
  routes: [
    {
      path: pathKey.homePath,
      name: 'HomePage',
      redirect: pathKey.familyStatusPath,
      component: HomePage,
      children: [
        {
          path: pathKey.familyStatusPath,
          name: 'FamilyPage',
          component: FamilyPage,
          meta: {
            title: '上品尚生智能后台',
            keepAlive: true
          },
        },
        {
          path: pathKey.familyStatusDetailPath,
          name: 'FamilyStatusDetail',
          component: FamilyStatusDetail,
          children: [
            {
              path: pathKey.familyStatusElectricityDetail,
              name: 'ElectricityPage',
              component: ElectricityPage,
              meta: {
                title: '电量统计',
              },
            },
            {
              path: pathKey.familyStatusWaterDetail,
              name: 'WaterPage',
              component: WaterPage,
              meta: {
                title: '水量统计'
              },
            },
            {
              path: pathKey.familyStatusGasDetail,
              name: 'GasPage',
              component: GasPage,
              meta: {
                title: '气量统计'
              },
            },
            {
              path: pathKey.familyStatusEnvironmentDetail,
              name: 'EnvironmentPage',
              component: EnvironmentPage,
              meta: {
                title: '环境能耗统计'
              },
            },
            {
              path: pathKey.energyDetail,
              name: 'EnergyDetailPage',
              component: EnergyDetailPage,
              meta: {
                title: '电量详情统计'
              },
            },
            {
              path: pathKey.familyStatusSmartEnergyPath,
              name: 'SmartEnergyPage',
              component: SmartEnergyPage,
              meta: {
                title: '智能能耗统计'
              }
            }
          ]
        },
        {
          path: pathKey.familyEquipmentDetailPath,
          name: 'EquipmentPage',
          component: EquipmentPage,
          meta: {
            title: '设备详情'
          },
        },
        {
          path: pathKey.infoManagePath,
          name: 'InfoManagePage',
          component: InfoManagePage,
          meta: {
            title: '信息维护'
          },
        },
        {
          path: pathKey.afterSaleManagePath,
          name: 'AfterSaleManage',
          component: AfterSaleManage,
          meta: {
            title: '售后管理'
          },
        }
      ]
    },
    {
      path: pathKey.loginPath,
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        title: '登录'
      },
    },
    {
      path: pathKey.errorPath,
      name: 'ErrorPage',
      component: ErrorPage,
      meta: {
        title: '网址错误'
      },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/routers.js